import { Plus } from "@icons/untitled_ui_icons";
import { AriaButton } from "@src/components/ui-components/Buttons/AriaButton/AriaButton";
import { t } from "i18next";
import { useState } from "react";
import { PropertyData } from "../../../to-be-removed/LocalData/Property/PropertyData";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { PropertySelector } from "../PropertySelector/PropertySelector";
import { Text } from "../Text/Text";

type PropertySelectorProps = {
  id?: string;
  properties: PropertyData[];
  defaultSelectedProperties?: PropertyData[];
  isMulti: boolean;
  chosenSelected: (properties: PropertyData[]) => void;
  placeholder?: string;
  disallowEmpty?: boolean;
  title?: string;
  label?: string;
  disableSelectAll?: boolean;
};

export const PropertySelectorPopUp = (props: PropertySelectorProps) => {
  const [selectedProperties, setSelectedProperties] = useState<PropertyData[]>(props.defaultSelectedProperties ?? []);

  const onToggleAll = () => {
    setSelectedProperties(props.properties);
  };

  const isDisabled = props.disallowEmpty && !selectedProperties.length;
  const isAllSelected = selectedProperties.length === props.properties.length && props.disableSelectAll;

  return (
    <ModalPopup
      onActionClicked={() => {
        return props.chosenSelected(selectedProperties);
      }}
      title={props.title ?? t("main.selectProperties")}
      actionTitle={t("main.continue")}
      disableAction={isDisabled || isAllSelected}
      id={props.id ?? ""}
      children={
        <div style={{ maxWidth: "500px" }} id="property-select-pop-up">
          {props.label && <Text text={props.label} textAlign="left" marginBottom={16} />}
          <PropertySelector
            placeholder={t("main.selectProperties")}
            properties={props.properties}
            defaultSelected={props.defaultSelectedProperties}
            isMulti={props.isMulti}
            changedSelectedProperties={setSelectedProperties}
            width={"100%"}
            optionsSelected={selectedProperties}
            disableSelectAll={props.disableSelectAll}
          />
          {!props.disableSelectAll && props.isMulti && selectedProperties.length !== props.properties.length && (
            <AriaButton variant="tertiary" style={{ marginTop: 8 }} onPress={onToggleAll} size="sm">
              <Plus />
              {t("main.selectAllProperties")}
            </AriaButton>
          )}

          {isAllSelected && <Text text={t("main.allPropertiesRemoved")} color="danger" textAlign="left" marginTop={8} size="sm" />}
        </div>
      }
    />
  );
};
